import React, { useState, useEffect } from 'react';

export default function ProgressBar({duration}) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const startTime = Date.now();
    const endTime = startTime + duration * 1000;
    const updateProgress = () => {
      const now = Date.now();
      const elapsedTime = now - startTime;
      const progressPercentage = (elapsedTime / (duration * 1000)) * 100;
      setProgress(progressPercentage);
      if (now < endTime) {
        requestAnimationFrame(updateProgress);
      }
    };

    updateProgress();

    // Cleanup function to cancel animation frame
    return () => cancelAnimationFrame(updateProgress);
  }, [duration]);

  return (
    <div
      className=""
      style={{
        marginTop: "20px",
        backgroundColor: "rgb(240, 242, 245)",
        width: "100%",
        height: "25px",
      }}
    >
      <div
        className="progress"
        style={{
          backgroundColor: "rgb(26, 119, 242)",
          width: `${progress}%`,
          height: "25px",
        }}
      ></div>
    </div>
  );
}
